import { TFormalOffers } from '@helpers/FormalOffers/formalOffers.types';
import { getHasSuitabilityInfo } from '@helpers/FormalOffers/getHasSuitabilityInfo';
import { getIsMicroOffer } from '@helpers/FormalOffers/getIsMicroOffer';
import { getIsRBLOffer } from '@helpers/FormalOffers/getIsRBLOffer';
import { getIsRCFOffer } from '@helpers/FormalOffers/getIsRCFOffer';

export type TOfferSetType =
    | 'micro'
    | 'recommended'
    | 'rcf'
    | 'rbl'
    | 'flexi_rcf'
    | 'flexi_rbl'
    | 'flexi'
    | null;

/** Classifies a DE formal offer set for new and loan-ended customers. */
export const getOfferSetType = (offers: TFormalOffers): TOfferSetType => {
    if (offers.length === 0) return null;

    if (offers.length === 1) {
        if (getIsMicroOffer(offers[0])) return 'micro';
        if (getIsRCFOffer(offers[0])) return 'rcf';
        if (getIsRBLOffer(offers[0])) return 'rbl';
        return 'flexi';
    }

    if (getHasSuitabilityInfo(offers[0])) return 'recommended';
    if (offers.some(getIsRCFOffer)) return 'flexi_rcf';
    if (offers.some(getIsRBLOffer)) return 'flexi_rbl';
    return 'flexi';
};
